/**
 * src/components/ui/Badge.jsx
 * Badge de estado con dot indicator.
 *
 * Los colores salen de index.css. Antes vivían aquí, en paralelo a los del
 * semáforo global y con valores distintos: el mismo estado se pintaba de dos
 * verdes según quién lo dibujara. Además ninguno llegaba a contraste legible
 * sobre su propio fondo — `warning` daba 1,96:1, medido.
 */

const COLORS = {
  green:  { bg: 'var(--color-ok-soft)',        color: 'var(--color-ok)' },
  red:    { bg: 'var(--color-error-soft)',     color: 'var(--color-error)' },
  yellow: { bg: 'var(--color-warn-soft)',      color: 'var(--color-warn)' },
  blue:   { bg: 'var(--color-running-soft)',   color: 'var(--color-running)' },
  gray:   { bg: 'var(--color-neutral-soft)',   color: 'var(--color-neutral)' },
  purple: { bg: 'var(--color-highlight-soft)', color: 'var(--color-highlight)' },
}

// Mapa semántico para resultados de pipeline
export const RESULTADO_COLOR = {
  ok:      'green',
  error:   'red',
  running: 'blue',
  warning: 'yellow',
}

export const TIER_COLOR = {
  premium: 'purple',
  pro:     'blue',
  basic:   'gray',
}

export function Badge({ children, color = 'gray', dot = false, pulse = false }) {
  const c = COLORS[color] || COLORS.gray

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 'var(--space-1)',
      background: c.bg, color: c.color,
      padding: 'var(--space-05) var(--space-2)', borderRadius: 'var(--radius-pill)',
      fontSize: 'var(--text-xs)', fontWeight: 'var(--weight-medium)',
      fontFamily: 'var(--font-mono)', letterSpacing: '0.04em',
      whiteSpace: 'nowrap',
    }}>
      {dot && (
        <span style={{
          width: '6px', height: '6px', borderRadius: 'var(--radius-pill)',
          background: 'currentColor', flexShrink: 0,
          ...(pulse ? { animation: 'pulseDot 1.4s ease-in-out infinite' } : {}),
        }} />
      )}
      {children}
    </span>
  )
}
